<template>
  <div class="filtered-product-grid">
    <load-more-results
      ref="loadMore"
      :has-more="hasMore"
      :initial-results="initialResults"
      :initial-items-number="initialItemsNumber"
      :total-items-number="totalItemsNumber"
      :more-items-number="moreItemsNumber"
      :api-url="apiUrl"
      :load-more-cta-label-part1="loadMoreCtaLabelPart1"
      :load-more-cta-label-part2="loadMoreCtaLabelPart2"
      :loading-state-label="loadingStateLabel"
      :load-parameters="loadParameters"
      :has-bazaar-voice-inline-ratings="hasBazaarVoiceInlineRatings"
      :channel-advisor="channelAdvisor"
      :square-images="squareImages"
      :wtb-id="wtbId"
      :mik-mak-product-id-type="mikMakProductIdType"
    >
      <slot />

      <div slot="loading">
        <slot name="loading" />
      </div>

      <template slot="no-results">
        <slot name="no-results" />
      </template>
    </load-more-results>
  </div>
</template>

<script>
  import LoadMoreResults from '@Feature/LoadMoreResults/code/Scripts/components/LoadMoreResults/LoadMoreResults.vue';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'FilteredProductGrid',
    components: {
      LoadMoreResults,
    },
    props: {
      totalItemsNumber: {
        type: Number,
        required: true,
      },
      initialItemsNumber: {
        type: Number,
        required: true,
      },
      moreItemsNumber: {
        type: Number,
        required: true,
      },
      apiUrl: {
        type: String,
        required: true,
      },
      loadMoreCtaLabelPart1: {
        type: String,
        required: false,
        default: 'View',
      },
      loadMoreCtaLabelPart2: {
        type: String,
        required: false,
        default: 'more >',
      },
      loadingStateLabel: {
        type: String,
        required: false,
        default: 'Loading more results',
      },
      hasMore: {
        type: Boolean,
        required: false,
        default: false,
      },
      initialResults: {
        type: Array,
        required: true,
        default: undefined,
      },
      hasBazaarVoiceInlineRatings: {
        type: Boolean,
        required: false,
        default: false,
      },
      loadParameters: {
        type: Object,
        required: true,
      },
      channelAdvisor: {
        type: Boolean,
        required: false,
        default: false,
      },
      squareImages: {
        type: Boolean,
        required: false,
        default: false,
      },
      wtbId: {
        type: String,
        required: false,
        default: null,
      },
      mikMakProductIdType: {
        type: String,
        required: false,
        default: null,
      },
    },
    computed: {
      ...mapGetters('searchFiltersStore', [
        'selectedProductsFiltersIds',
        'selectedProductsSorting',
      ]),
    },
    watch: {
      selectedProductsFiltersIds: {
        handler() {
          this.filterProducts();
        },
        deep: true,
      },
      selectedProductsSorting: {
        handler(newSelected, oldSelected) {
          if (oldSelected) {
            this.filterProducts();
          }
        },
      },
    },
    methods: {
      ...mapActions('searchFiltersStore', ['setProductsFilters', 'setIsLoadingFilters']),
      filterProducts() {
        this.setIsLoadingFilters(true);
        const parseJSON = response => response.json();
        this.loadParameters.selectedFilters = this.selectedProductsFiltersIds;
        this.loadParameters.skip = 0;
        this.loadParameters.selectedSorting = this.selectedProductsSorting;
        fetch(this.apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json;charset=utf-8' },
          credentials: 'same-origin',
          body: JSON.stringify(this.loadParameters),
        })
          .then(parseJSON)
          .then(data => {
            this.setIsLoadingFilters(false);
            if (data.loadParameters && data.results && data.productsFilters) {
              this.resetLoadMore(
                data.results,
                data.loadParameters,
                data.productsFilters.count - data.results.length,
                this.itemsLeft <= 0 ? false : data.hasMore
              );
            }
            if (data.productsFilters) {
              this.setProductsFilters(data.productsFilters);
            }
          })
          .catch(error => {
            this.setIsLoadingFilters(false);
            console.error('Could not load results', error); // eslint-disable-line no-console
          });
      },
      resetLoadMore(loadList, parameters, itemsLeft, hasMoreResultsToLoad) {
        this.$refs.loadMore.resetComponent(loadList, parameters, itemsLeft, hasMoreResultsToLoad);
      },
    },
  };
</script>
